import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';

import { SocialApiPopupService, SocialMediaType } from '@hiptraveler/data-access/api';
import { BrandState } from '@hiptraveler/data-access/brand';
import { PromptDialogActionService } from '@hiptraveler/dialogs/prompt-dialog';
import { RegistrationFormStateService } from '../../common';
import { SocialMediaLinkComponent } from './social-media-link.component';
import { getWindowRef, openedWindowPopUp } from '@hiptraveler/common';
import { SocialMediaEventService } from './social-media-event.service';

@Directive({
  selector: '[socialMediaEvent]',
  providers: [ PromptDialogActionService, SocialMediaEventService ]
})
export class SocialMediaEventDirective implements OnInit {

  @Input() socialMediaEvent: [ SocialMediaLinkComponent, SocialMediaType ];

  constructor(
    private element: ElementRef<HTMLDivElement>,
    private store: Store,
    private socialApi: SocialApiPopupService,
    private formService: RegistrationFormStateService,
    private service: SocialMediaEventService
  ) { }
  
  ngOnInit(): void {

    this.socialApi.poolingSuccess$.subscribe(() => {
      this.element.nativeElement.classList.remove('pending');
    });

    this.formService.socialForm.valueChanges.subscribe((value) => {

      let socialObject = value[this.socialMediaEvent[1]];

      if (socialObject?.handle && typeof socialObject !== 'string') {
        socialObject = `${socialObject.handle}::${socialObject.id}`;
      }

      if (!socialObject) return;

      const element = this.element.nativeElement;
      const primaryColor = this.store.selectSnapshot(BrandState.campaignCustom)?.colorPalette?.mainColor || '#00a6ff';
      const text = element.getElementsByTagName('P').item(0) as HTMLElement;
      text.style.color = primaryColor;
      text.textContent = socialObject.split('::')[0] || text.textContent;

      const icon = element.querySelectorAll('.complete-svg').item(0) as HTMLElement
      icon.style.display = 'block';

      getWindowRef()[openedWindowPopUp]?.close();
    });
  }

  @HostListener('click')
  hostClicked(): void {

    const { invalid } = this.service.validateEvent(this.socialMediaEvent[1]);

    if (invalid) return;

    this.processEvent();
  }

  processEvent(): void {
    const value = this.formService.socialForm.value[this.socialMediaEvent[1]];
    if (value) return;
    const component = this.socialMediaEvent[0];
    const type = this.socialMediaEvent[1];
    component.socialClicked.emit(type);
    this.element.nativeElement.classList.add('pending');
  }

}
